import React, { Component } from "react"
import { Grid, Row, Col, Button } from "react-bootstrap"
import { Link } from "react-router-dom"
import { fetchUserRequest } from "../../api/user"
import { getFullName } from "helpers/functions/employee";

class UserDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                email: null,
                role: null,
                employee: {}
            }
        }
    }

    componentDidMount() {
        const { match } = this.props;
        if(match.params.id) {
            this.fetchUser(match.params.id)
        }
    }

    fetchUser = (id) => {
        fetchUserRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    goToUserList = () => {
        this.props.history.push('/users/list')
    }

    goToUserEditForm = (id) => {
        this.props.history.push('/users/edit/' + id)
    }

    render() {

        const { 
            _id,
            email,
            role,
            employee
        } = this.state.resource;

        return (
            <div className="content">
                <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        User Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={this.goToUserList}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                    <div className="typo-line">
                        <div>
                        <p className="category">User ID</p>
                        {_id || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Email</p>
                        {email || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Role</p>
                        {role || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Employee</p>
                        {employee ? <Link to={"/employees/details/" + employee._id}>{getFullName(employee)}</Link> : 'N/A'}
                        </div>
                    </div>
                    
                    <Button className="btn btn-primary bottom-btn" onClick={() => this.goToUserEditForm(_id)}>Edit User</Button>
                    </Col>
                </Row>
                </Grid>
            </div>
        );
    }
}

export default UserDetails;
